import React from 'react';
import './styles.css'
import Gallery from '../Gallery/Gallery'
import BurgerMenu from '../BurgerMenu/BurgerMenu'
import Home from '../Home/Home'
import logo from "../../obrazky/logo.png";

import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import {Link} from 'react-router-dom'

export default function Navigation() {
    return(
    <Router>
        <div className="main-nav">
        <Link to="/" className={'div-logo'}><img src={logo} className="logo" alt="Babincak logo"/></Link>
            <h1>Miroslav <br className="mobile-heading"/> Babinčák</h1>
            <BurgerMenu />
        </div>
        <Switch>
            <Route path="/" exact>
                <Home />
            </Route>
            <Route path="/3d-napisy" exact>
                <Gallery header={'3D Nápisy'} gallery={'3d-napisy'} />
            </Route>
            <Route path="/malovana-reklama" exact>
                <Gallery header={'Maľovaná reklama'} gallery={'malovana-reklama'} />  
            </Route>
            <Route path="/obrazy" exact>
                <Gallery header={'Obrazy'} gallery={'obrazy'} />  
            </Route>
            <Route path="/kreslene-portrety" exact>
                <Gallery header={'Kreslené portréty'} gallery={'kreslene-portrety'} />  
            </Route>
            <Route path="/airbrush" exact>
                <Gallery header={'Airbrush'} gallery={'airbrush'} />  
            </Route>
            <Route path="/tetovania" exact>
                <Gallery header={'Tetovania'} gallery={'tetovania'} />  
            </Route>
            <Route path="/foto" exact>
                <Gallery header={'Foto'} gallery={'foto'} />  
            </Route>
        </Switch>
    </Router>
    )
}